import { Switch } from '@mui/material';

export function ToggleSwitch({ configuration }) {
  function handleChange(event) {
    configuration?.toggle?.(event.target.checked);
  }

  return (
    <Switch
      size="small"
      checked={configuration?.isEnabled ?? false}
      onChange={handleChange}
      disabled={configuration.isPending ?? true}
    />
  );
}
